export enum StatusCode {
  // 触发限流
  TriggerRateLimit = 40010023,
  // 验证码已发送，请稍后重试
  SmsSentRetryLater = 40010028,
  // 未授权
  Unauthorized = 401,
  // 滑块验证通过但是密码报错
  SliderPasswordErr = 40010119,
  // 密码登录错误码
  PasswordErr = 40010019,
  // 滑动验证失败
  VerificationFailed = 40010026,
  // Verification code has expired, please try again
  VerificationExpired = 40010025,
  // 邮箱重复绑定，
  EmailBound = 40010001,
  // 没有邮箱
  NoEmail = 40010000,
  // 绑定邮箱时提示需要输入密码
  VerifyThirdLoginEmailError = 40010056,
}
